/**
 * Shader code for gradient sphere
 */

export const gradientSphereVertexShader = `
  varying vec2 vUv;
  void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`;

export function createGradientSphereFragmentShader(): string {
  return `
    uniform float uBlueHue;
    uniform float uBlueSaturation;
    uniform float uBlueLightness;
    uniform vec3 uWhite;
    uniform vec3 uBlack;
    uniform float uThreshold1;
    uniform float uThreshold2;
    uniform float uThreshold3;
    
  varying vec2 vUv;

  vec3 hslToRgb(float h, float s, float l) {
    float c = (1.0 - abs(2.0 * l - 1.0)) * s;
    float x = c * (1.0 - abs(mod(h / 60.0, 2.0) - 1.0));
    float m = l - c / 2.0;
    vec3 rgb;
    if (h < 60.0) rgb = vec3(c, x, 0.0);
    else if (h < 120.0) rgb = vec3(x, c, 0.0);
    else if (h < 180.0) rgb = vec3(0.0, c, x);
    else if (h < 240.0) rgb = vec3(0.0, x, c);
    else if (h < 300.0) rgb = vec3(x, 0.0, c);
    else rgb = vec3(c, 0.0, x);
    return rgb + m;
  }

  void main() {
    float y = vUv.y;
    vec3 color;
      vec3 white = uWhite;
      vec3 blue = hslToRgb(uBlueHue, uBlueSaturation, uBlueLightness);
      vec3 black = uBlack;

      float range1 = 1.0 - uThreshold1; // Top range (uThreshold1 to 1.0)
      float range2 = uThreshold1 - uThreshold2; // Upper middle range
      float range3 = uThreshold2 - uThreshold3; // Lower middle range
      float range4 = uThreshold3; // Bottom range (0.0 to uThreshold3)

      if (y > uThreshold1) {
        float t = (y - uThreshold1) / range1;
      color = mix(blue, white, t);
      } else if (y > uThreshold2) {
        float t = (y - uThreshold2) / range2;
      color = mix(black, blue, t);
      } else if (y > uThreshold3) {
        float t = (y - uThreshold3) / range3;
      color = mix(blue, black, t);
    } else {
        float t = y / range4;
      color = mix(white, blue, t);
    }

    gl_FragColor = vec4(color, 1.0);
  }
`;
}
